<template lang="pug">
modal(active, title='Vincular autor ao afiliado', @close='$router.back()')
  div(slot='modal-body')
    cite O pagamento por conteúdo assistido será passado para esta conta de afiliado.
    .text-bold Este processo é necessário caso deseje que o autor seja remunerado.
    .divider
    form.pt-2(@submit.prevent="filter")
      .columns
        .column
          input.form-input(placeholder="Nome do autor" v-model.trim="q.name")
        .column.col-auto
          button.btn.btn-primary.btn-action.tooltip.tooltip-left(data-tooltip="Filtrar")
            i.fas.fa-filter
    list-manager(:loading="loading" :error="error" :paginated-list="list" @fetch-data="fetchData")
      table.table(v-if="list")
        thead
          tr
            th Nome do autor
            th
        tbody
          tr(v-for="author in list.rows")
            td {{ author.name }}
            td.text-right
              a.btn.btn-primary.btn-action.btn-sm.tooltip.tooltip-left(
                data-tooltip="Escolher autor"
                @click="selectAuthor(author)"
              )
                i.fas.fa-check
</template>

<script>
import authors from '@/services/authors'
import filiations from '@/services/filiations'

export default {
  data() {
    return {
      q: { name: '' },
      list: null,
      loading: false,
      error: null,
    }
  },
  watch: {
    '$route.query.q'() {
      const params = this.$route.query
      this.fetchData(params)
    },
  },

  props: {
    refreshList: { type: Function, required: true },
  },

  methods: {
    async fetchData(params = {}) {
      try {
        this.loading = true
        const { data } = await authors.list({
          ...params,
          take: 8,
          q: { ...(params.q || {}) },
        })
        this.list = data
      } catch (e) {
        this.error = e
      } finally {
        this.loading = false
      }
    },
    filter() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          q: this.q,
          page: 1,
        },
      })
    },
    async selectAuthor({ name, id }) {
      const options = {
        size: 'sm',
        title: 'Confirmar vínculo',
        okLabel: 'Sim',
        cancelLabel: 'Não',
      }
      const { ok } = await this.$dialogs.confirm(
        `Deseja vincular o autor ${name} a este afiliado?`,
        options,
      )
      if (!ok) return
      try {
        await filiations.update(this.$route.params.id, { author: { id } })
        this.$toaster.success('Autor vinculado')
        this.refreshList()
        this.$router.back()
      } catch (e) {
        console.log(e)
        this.$toaster.error(e.message)
      }
    },
  },
  created() {
    const params = this.$route.query
    const { q = {} } = this.$route.query
    this.q = q
    this.fetchData(params)
  },
}
</script>
